import React from 'react';
import './content.css'

export default function (props){
    return(
        <div className='content'>
            <p> { props.content } </p>
        </div>
    )
}